/* eslint-disable no-undef */
import $ from "jquery";
import StaticMapComponent from "./components/static-map.component";
import SearchMapComponent from "./components/search-map.component";
import ErrorService from "./services/error.service";

const isGmAvaliable = typeof window.google !== "undefined" && typeof window.google.maps !== "undefined";

function loadStaticGoogleMap(hideConsentMessage) {
    if (!$(".static-map-js-component").length) {
        return;
    }

    if (!isGmAvaliable) {
        ErrorService.showCommonError("Map Component cannot be shown because of Google Maps script is missing.");
        return;
    }

    const staticMaps = [];

    $(".static-map-js-component").each(function createStaticMapComponent() {
        staticMaps.push(new StaticMapComponent($(this)));
        if (hideConsentMessage) {
            $(".search-map-consent-message").remove();
        }
    });
}

function loadGoogleMap(hideConsentMessage) {
    if (!$(".search-map-js-component").length) {
        return;
    }

    if (!isGmAvaliable) {
        ErrorService.showCommonError("Map Component cannot be shown because of Google Maps script is missing.");
        return;
    }

    const searchMaps = [];
    $(".search-map-js-component").each(function createSearchMapComponent() {
        searchMaps.push(new SearchMapComponent($(this)));
    });

    if (hideConsentMessage) {
        $(".search-map-consent-message").remove();
    }
}

const sitecoreContext = $(".search-map-consent-message").attr("data-sitecore-context");

// eslint-disable-next-line no-restricted-globals
if (location.search.indexOf("pdf=1") >= 0) {
    loadStaticGoogleMap(true);
} else if (sitecoreContext != null && sitecoreContext === "ee") {
    loadGoogleMap(false);
    loadStaticGoogleMap(false);
} else if (sitecoreContext != null && sitecoreContext === "ep") {
    loadGoogleMap(true);
    loadStaticGoogleMap(true);
} else {
    document.addEventListener("cookies-accept:required", () => loadGoogleMap(true));
    document.addEventListener("cookies-accept:required", () => loadStaticGoogleMap(true));
}
